(function ($) {
  const videoModal = function () {
    const loader = $('#videoLoader');
    const modal = $('#modalVideo');

    $('.video-tile, .video-card .title').on('click', function () {
      const videoid = $(this).data('id');
      let videoFile = `https://player.vimeo.com/video/${videoid}?autoplay=1`;

      loader.css({
        display: 'block',
        opacity: 1,
      }).attr('src', videoFile);
    });

    modal.on('hidden.bs.modal', () => {
      loader.attr('src', ''); // Unload the video to stop playback
    });
  };

  const showVideos = function () {
    $('.cta-videos a').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      let count = 1;

      if ($(this)[0].id === 'seeMoreVideos') {
        // Display the next three video cards
        const hiddenVideos = $('.component-videos-container').find('.hidden');

        $(hiddenVideos).each(function () {
          if (hiddenVideos.length) {
            if (count <= 3) {
              $(this).removeClass('hidden');
              $(this).addClass('shown');
              count++;

              const checkHiddenVideos = $('.component-videos-container').find('.hidden');
              if (checkHiddenVideos.length === 0) {
                // Replace "See More" cta with "See Less"
                $('#seeLessVideos').addClass('active');
                $('#seeMoreVideos').removeClass('active');
              }
            }
          }
        });
      }

      if ($(this)[0].id === 'seeLessVideos') {
        // Replace "See Less" cta with "See More"
        $('#seeLessVideos').removeClass('active');
        $('#seeMoreVideos').addClass('active');

        const shownVideos = $('.component-videos-container').find('.shown');

        if (shownVideos.length) {
          // Hide all video cards but show the first three
          $(shownVideos).each(function () {
            if (count > 3) {
              $(this).removeClass('shown');
              $(this).addClass('hidden');
            }
            count++;
          });
        }
      }
    });
  };

  const init = function () {
    if ($('.component-videos-container').length) {
      videoModal();
      showVideos();
    } else if ($('.video-tile, .video-card .title').length) {
      videoModal();
    }
  };

  $(init);
}(jQuery));
